import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { threadClient } from '#pplx_generated/typespec/rest/thread/client.js';
export const mentionThreadMembers = async ({ params, reason, }) => {
    const { data, error, response } = await threadClient.POST('/rest/thread/mention', reason, {
        body: params,
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to share thread with mentioned users',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=mentionThreadMembers.js.map